import type { ComponentType } from "react";
import Link from "next/link";
import { IdCard, X, Headphones } from "@/components/icons";
import { ROUTES } from "@/lib/constants";

type IconComponent = ComponentType<{
  size?: number;
  className?: string;
  "aria-hidden"?: "true";
}>;

type BenefitItem = { label: string; icon: IconComponent };

const DEFAULT_ITEMS: BenefitItem[] = [
  { label: "KYC required", icon: IdCard },
  { label: "Cancel anytime", icon: X },
  { label: "Premium support", icon: Headphones },
];

export function TrustBenefitList({
  items = DEFAULT_ITEMS,
  className,
}: {
  items?: BenefitItem[];
  className?: string;
}) {
  return (
    <ul className={className} aria-label="Key benefits">
      {/* Darkened on the light theme only — muted-foreground sits too pale
          against the white hero; the dark theme keeps its tuned value. The icon
          carries no colour of its own, so currentColor keeps it matched. */}
      {items.map(({ label, icon: Icon }) => {
        const isKyc = label.toLowerCase().includes("kyc");
        return (
          <li
            key={label}
            className="text-muted-foreground light:text-foreground/80 flex items-center gap-2 text-sm"
          >
            <Icon size={14} aria-hidden="true" />
            {isKyc ? (
              <Link href={ROUTES.kyc} className="hover:text-foreground transition-colors">
                {label}
              </Link>
            ) : (
              label
            )}
          </li>
        );
      })}
    </ul>
  );
}
